import { gql } from '@apollo/client';

export const REGISTER = gql`
  mutation CustomerRegister($input: CustomerRegistrationInput) {
    customerRegister(input: $input) {
      token
      customerId
    }
  }
`;

export const LOGIN = gql`
  mutation CustomerLogin($input: CustomerLoginInput) {
    customerLogin(input: $input) {
      token
      customerId
    }
  }
`;

export const LOGIN_WITH_GOOGLE = gql`
  mutation CustomerLoginWithGoogle($code: String!) {
    customerLoginWithGoogle(code: $code) {
      token
      customerId
    }
  }
`;

export const START_PHONE_VERIFICATION = gql`
  mutation CustomerStartPhoneVerification($phone: String!, $purpose: PhoneVerificationPurpose!) {
    customerStartPhoneVerification(phone: $phone, purpose: $purpose) {
      sessionId
      phone
      status
      smsUri
      displayInstruction
      expiresAt
    }
  }
`;

export const PHONE_VERIFICATION_STATUS = gql`
  query CustomerPhoneVerificationStatus($sessionId: String!) {
    customerPhoneVerificationStatus(sessionId: $sessionId) {
      sessionId
      phone
      status
      expiresAt
      verifiedAt
    }
  }
`;

export const LOGIN_WITH_PHONE = gql`
  mutation CustomerLoginWithPhone($sessionId: String!) {
    customerLoginWithPhone(sessionId: $sessionId) {
      token
      customerId
    }
  }
`;

export const RESET_PASSWORD_WITH_PHONE = gql`
  mutation CustomerResetPasswordWithPhone($sessionId: String!, $newPassword: String!) {
    customerResetPasswordWithPhone(sessionId: $sessionId, newPassword: $newPassword)
  }
`;

export const REQUEST_PASSWORD_RESET = gql`
  mutation CustomerRequestPasswordReset($email: String!) {
    customerRequestPasswordReset(email: $email)
  }
`;

export const RESET_PASSWORD = gql`
  mutation CustomerResetPassword($email: String!, $code: String!, $newPassword: String!) {
    customerResetPassword(email: $email, code: $code, newPassword: $newPassword)
  }
`;

export const LOGOUT = gql`
  mutation CustomerLogout {
    customerLogout
  }
`;

export const VERIFY_EMAIL = gql`
  mutation CustomerVerifyEmail($email: String!, $code: String!) {
    customerVerifyEmail(email: $email, code: $code)
  }
`;

export const VERIFY_PHONE = gql`
  mutation CustomerVerifyPhone($phone: ID!, $code: String!) {
    customerVerifyPhone(phone: $phone, code: $code)
  }
`;

export const RESEND_VERIFICATION = gql`
  mutation ResendVerification($email: String!) {
    resendVerification(email: $email) {
      success
      message
    }
  }
`;

export const ADD_TO_CART = gql`
  mutation CustomerAddCartItem(
    $productId: ID!
    $quantity: Int
  ) {
    customerAddCartItem(
      productId: $productId
      quantity: $quantity
    ) {
      id
    }
  }
`;

export const REMOVE_FROM_CART = gql`
  mutation CustomerRemoveCartItem($customerRemoveCartItemId: ID!) {
    customerRemoveCartItem(id: $customerRemoveCartItemId)
  }
`;

export const UPDATE_CART_ITEM = gql`
  mutation CustomerUpdateCartItem(
    $customerUpdateCartItemId: ID!
    $quantity: Int
  ) {
    customerUpdateCartItem(id: $customerUpdateCartItemId, quantity: $quantity) {
      id
    }
  }
`;

export const CLEAR_CART = gql`
  mutation CustomerClearCart {
    customerClearCart
  }
`;

export const CREATE_ORDER = gql`
  mutation CustomerAddOrder($input: OrderInput) {
    customerAddOrder(input: $input) {
      id
      paymentData
      orderNumber
    }
  }
`;

export const SET_ADDRESS = gql`
  mutation CustomerSetAddress($input: AddressInput) {
    customerSetAddress(input: $input) {
      cityId
    }
  }
`;

export const REGISTER_PUSH_TOKEN = gql`
  mutation CustomerRegisterToken($fcmToken: String!) {
    customerRegisterToken(fcmToken: $fcmToken)
  }
`;

export const EDIT_PROFILE = gql`
  mutation CustomerEditProfile($input: CustomerInput) {
    customerEditProfile(input: $input) {
      id
    }
  }
`;

export const TOGGLE_FAVORITE = gql`
  mutation CustomerToggleFavorite($productId: ID!) {
    customerToggleFavorite(productId: $productId) {
      id
      favorite
    }
  }
`;
